// extracted by mini-css-extract-plugin
export default {"FormActions":"FormActions_FormActions__7kQy5"};